
export default {
  name: 'CustomHr',
  props: {
    // Line properties
    color: {
      type: String,
      default: '#70707099',
    },
    width: {
      type: String,
      default: '1px',
    },
    lineWidth: {
      type: String,
      default: '100%',
    },
    // Spacing properties
    padding: {
      type: String,
      default: '0px',
    },
    marginTop: {
      type: String,
      default: '10px',
    },
    marginBottom: {
      type: String,
      default: '10px',
    },
    marginLeft: {
      type: String,
      default: '0px',
    },
    marginRight: {
      type: String,
      default: '0px',
    },
  },
}
